import type { AppRoute } from 'src/routes/types';

import { Report } from '@mui/icons-material';
import { t } from 'i18next';
import { lazy } from 'react';

const ReportListView = lazy(() => import('./views/ReportListView.tsx'));
const ReportEditView = lazy(() => import('./views/ReportEditView.tsx'));
const ReportCreateView = lazy(() => import('./views/ReportCreateView.tsx'));

export const deviationRoutePaths = {
  deviationReportCreate: '/deviation/reports/create',
  deviationReportEdit: '/deviation/reports/:id',
  deviationReportList: '/deviation/reports',
} as const;

export const deviationRoutes: AppRoute[] = [
  {
    element: <ReportListView />,
    enabled: true,
    menu: {
      group: 'tools',
      icon: <Report />,
      title: () => t('deviation:DEVIATIONS'),
    },
    path: deviationRoutePaths.deviationReportList,
    permission: 'all',
    scope: 'private',
  },
  {
    element: <ReportEditView />,
    enabled: true,
    path: deviationRoutePaths.deviationReportEdit,
    permission: 'all',
    scope: 'private',
  },
  {
    element: <ReportCreateView />,
    enabled: true,
    path: deviationRoutePaths.deviationReportCreate,
    permission: 'all',
    scope: 'private',
  },
];
